import { render, staticRenderFns } from "./money-editor.vue?vue&type=template&id=776074a4&"
import script from "./money-editor.vue?vue&type=script&lang=ts&"
export * from "./money-editor.vue?vue&type=script&lang=ts&"
import style0 from "./money-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./money-editor.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports